export default __webpack_public_path__ + "dist/media/Diamond.0a307f42.svg";